/**
 * Builds a lookup of grid field key → display title from API `columnDefinitions`.
 * Used when the task list is empty so headers still match configured labels (e.g. Theme vs Project).
 */
export const buildColumnTitleMap = (columnDefinitions) => {
  const map = {};
  columnDefinitions?.forEach((cd) => {
    if (cd?.Column != null) {
      map[cd.Column] = cd.Title;
    }
  });
  return map;
};

/**
 * Grid column header: prefer API columnDefinitions map, then first row cell Title, then raw key.
 */
export const resolveConfigurableColumnTitle = (columnKey, columnTitleMap, firstRow) =>
  columnTitleMap?.[columnKey] || firstRow?.[columnKey]?.Title || columnKey;

/**
 * Excel export column title: same as grid but no fallback to raw column key (optional undefined).
 */
export const resolveConfigurableExcelColumnTitle = (columnKey, columnTitleMap, firstRow) =>
  columnTitleMap?.[columnKey] || firstRow?.[columnKey]?.Title;
